import React, { useMemo } from 'react';
import { compareDesc } from 'date-fns';
import {
  ModalFloatingCloseBtn,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import { useGetBillingHistoryQuery } from '@order/graphql';
import { useTrackEventEffect } from '@order/Telemetry';

import { LoadingAnimation } from '../../components/LoadingAnimation';
import { PageWrapper } from '../../components/PageWrapper';
import { TransparentModal } from '../../components/TransparentModal';
import { useNavigateBack } from '../../navigation';
import { SweetpassBillingHistoryScreenContent } from './SweetpassBillingHistoryScreenContent';

export const SweetpassBillingHistoryScreen = () => {
  const handlePressClose = useNavigateBack();

  const { isMobile } = useBreakpointHelpers();

  const [{ data, fetching: isLoading }] = useGetBillingHistoryQuery({
    requestPolicy: 'cache-and-network',
  });

  const sortedBillingHistory = useMemo(() => {
    const subscriptionsBillingHistory =
      data?.getSubscriptions.flatMap(
        (subscription) => subscription.billingHistory,
      ) ?? [];

    return subscriptionsBillingHistory
      .map((billingHistory) => ({
        ...billingHistory,
        date: new Date(billingHistory.date),
      }))
      .sort((a, b) => compareDesc(a.date, b.date));
  }, [data?.getSubscriptions]);

  useTrackEventEffect({
    name: 'sweetpass_account.billing_history.viewed',
    skip: isLoading || !sortedBillingHistory,
  });

  if (isLoading && !sortedBillingHistory) return <LoadingAnimation />;

  if (!sortedBillingHistory) return null;

  return (
    <TransparentModal size="xsmall" onClose={handlePressClose}>
      {isMobile ? null : <ModalFloatingCloseBtn onPress={handlePressClose} />}
      <PageWrapper
        withHeaderTitle
        withoutFooter
        testID="sweetpass-membership.billing-history.page"
      >
        <SweetpassBillingHistoryScreenContent
          testID="sweetpass-membership.billing-history"
          billingHistory={sortedBillingHistory}
        />
      </PageWrapper>
    </TransparentModal>
  );
};
